import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import safeT from 'helpers/safeT/safeT';
import { Option } from 'types/Option';
import { TableFilterEntity } from 'types/TableFilter';

const useSortedItems = () => {
  const { t } = useTranslation();

  const sortItems = useCallback(
    <T>(items: T[], labelExtractor: (item: T) => string | string[]): T[] => {
      if (!items) return [];
      return [...items].sort((a, b) => {
        const labelA = labelExtractor(a);
        const labelB = labelExtractor(b);

        const translatedA = Array.isArray(labelA) ? safeT(t, labelA[0], labelA[1]) : labelA;
        const translatedB = Array.isArray(labelB) ? safeT(t, labelB[0], labelB[1]) : labelB;

        return translatedA.localeCompare(translatedB);
      });
    },
    [t],
  );

  const sortOptions = useCallback((options: Option[]) => sortItems(options, option => option.label), [sortItems]);

  const sortTableFilters = useCallback((filters: TableFilterEntity[]) => sortItems(filters, filter => filter.name), [sortItems]);

  return { sortItems, sortOptions, sortTableFilters };
};

export default useSortedItems;
